import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import treePurpleSrc from '@cover/weiterlernen/purple-tree.png';
import treeBottomRightSrc from '@cover/weiterlernen/small-tree-bottom-right.png';
import treeBottomLeftSrc from '@cover/weiterlernen/tree-bottom-left2.png';
import treeTopLeftSrc from '@cover/weiterlernen/tree-top-left.png';
import treeTopMiddleSrc from '@cover/weiterlernen/tree-top-middle.png';
import treeTopRightSrc from '@cover/weiterlernen/tree-top-right.png';

const AnimatedLayer = styled.img`
	position: absolute;
`

const TreePurple = styled(AnimatedLayer)`
	height: 93%;
	top: 14%;
	left: -2%;
	transform-origin: bottom center;
`
const TreeBottomRight = styled(AnimatedLayer)`
	width: 90%;
	bottom: -9.5%;
	right: -22%;
	transform-origin: bottom center;
	z-index: 999;
`
const TreeBottomLeft = styled(AnimatedLayer)`
	height: 81%;
	top: 36%;
	left: -38%;
	transform-origin: bottom center;
`
const TreeTopLeft = styled(AnimatedLayer)`
	height: 82%;
	top: -59%;
	left: -37%;
	transform-origin: top left;
`
const TreeTopMiddle = styled(AnimatedLayer)`
	height: 32%;
	top: -5.5%;
	right: 29.5%;
	transform-origin: top center;
	z-index: 999;
`
const TreeTopRight = styled(AnimatedLayer)`
	height: 40%;
	top: -6.5%;
	right: -6%;
	transform-origin: top right;
	z-index: 999;
`

const WeiterLernen = ({ play }) => {
	const treePurple = createRef();
	const treeBottomRight = createRef();
	const treeBottomLeft = createRef();
	const treeTopLeft = createRef();
	const treeTopMiddle = createRef();
	const treeTopRight = createRef();

	useEffect(() => {

		anime({
			targets: treeBottomLeft.current,
			autoplay: play,
			loop: true,
			direction: 'alternate',
			keyframes: [
				{rotate: 0, duration: 800, easing: 'easeInOutSine'},
				{rotate: 0.5, duration: 800, easing: 'easeInOutSine'},
				{rotate: 0, duration: 800, easing: 'easeInOutSine'},
				{rotate: 0.4, duration: 800, easing: 'easeInOutSine'},
				{rotate: 0, duration: 800, easing: 'easeInOutSine', endDelay: 800},
				{rotate: 0.5, duration: 800, easing: 'easeInOutSine'},
				{rotate: 0, duration: 800, easing: 'easeInOutSine', endDelay: 600},
				{rotate: 0.2, duration: 800, easing: 'easeInOutSine'},
				{rotate: 0, duration: 800, easing: 'easeInOutSine'},
			]
		})
		anime({
			targets: treePurple.current,
			autoplay: play,
			loop: true,
			direction: 'alternate',
			keyframes: [
				{rotate: 0, duration: 400, easing: 'easeInOutSine'},
				{rotate: -0.3, duration: 400, easing: 'easeInOutSine'},
				{rotate: 0, duration: 400, easing: 'easeInOutSine'},
				{rotate: -0.2, duration: 400, easing: 'easeInOutSine'},
				{rotate: 0, duration: 400, easing: 'easeInOutSine'},
				{rotate: -0.3, duration: 400, easing: 'easeInOutSine'},
				{rotate: 0, duration: 400, easing: 'easeInOutSine'},
				{rotate: -0.1, duration: 400, easing: 'easeInOutSine'},
				{rotate: 0, duration: 400, easing: 'easeInOutSine'},
			]
		})
		anime({
			targets: treeBottomRight.current,
			autoplay: play,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutElastic(1, .6)',
			keyframes: [
				{translateY: '0%',rotate: 0, duration: 50},
				{translateY: '-0.25%',rotate: 0.5, duration: 50},
				{translateY: '0%',rotate: 0, duration: 50, endDelay: 2000},
				{translateY: '0%',rotate: 0, duration: 50},
				{translateY: '-0.25%',rotate: 0.5, duration: 50},
				{translateY: '0%',rotate: 0, duration: 50},
				{translateY: '-0.25%',rotate: 0.5, duration: 50},
				{translateY: '0%',rotate: 0, duration: 50, endDelay: 2000},
			]
		}, 800)
		anime({
			targets: treeTopMiddle.current,
			autoplay: play,
			loop: true,
			direction: 'alternate',
			keyframes: [
				{translateY: '0%',rotate: 0, duration: 800, easing: 'easeInOutSine'},
				{translateY: '0.5%',rotate: -0.4, duration: 800, easing: 'easeInOutSine'},
				{translateY: '0%',rotate: 0, duration: 800, easing: 'easeInOutSine', endDelay: 400},
				{translateY: '0.5%',rotate: -0.3, duration: 800, easing: 'easeInOutSine'},
				{translateY: '0%',rotate: 0, duration: 800, easing: 'easeInOutSine'},
			]
		}, 1300)
		anime({
			targets: treeTopRight.current,
			autoplay: play,
			loop: true,
			direction: 'alternate',
			keyframes: [
				{translateY: '0%',rotate: 0, duration: 1000, easing: 'easeInOutSine'},
				{translateY: '0.5%', rotate: -0.4, duration: 1000, easing: 'easeInOutSine'},
				{translateY: '0%',rotate: 0, duration: 1000, easing: 'easeInOutSine', endDelay: 400},
				{translateY: '0.25%',rotate: -0.3, duration: 1000, easing: 'easeInOutSine'},
				{translateY: '0.5%',rotate: 0, duration: 1000, easing: 'easeInOutSine'},
			]
		}, 1500)
		anime({
			targets: treeTopLeft.current,
			autoplay: play,
			loop: true,
			direction: 'alternate',
			keyframes: [
				{translateX: '0%',rotate: 0, duration: 800, easing: 'easeInOutSine'},
				{translateX: '0.5%', rotate: -0.4, duration: 800, easing: 'easeInOutSine'},
				{translateX: '0%',rotate: 0, duration: 800, easing: 'easeInOutSine', endDelay: 800},
				{translateX: '0.25%',rotate: -0.3, duration: 800, easing: 'easeInOutSine'},
				{translateX: '0%',rotate: 0, duration: 800, easing: 'easeInOutSine'},
			]
		}, 1500)
	}, [play])
	return (
		<>
			<TreePurple src={treePurpleSrc} ref={treePurple}/>
			<TreeBottomLeft src={treeBottomLeftSrc} ref={treeBottomLeft}/>
			<TreeBottomRight src={treeBottomRightSrc} ref={treeBottomRight}/>
			<TreeTopLeft src={treeTopLeftSrc} ref={treeTopLeft}/>
			<TreeTopMiddle src={treeTopMiddleSrc} ref={treeTopMiddle}/>
			<TreeTopRight src={treeTopRightSrc} ref={treeTopRight}/>
		</>
	)
};

export default WeiterLernen;